/* template */
<template><div v-on="$listeners" :class='["mpx-root-view","host-_1491d0a4"]'><cube-slider @change='(e)=>__invoke(e, [["handleChange"]])' @changing='(e)=>__invoke(e, [["handleChanging"]])'></cube-slider></div></template>
/* styles */
/* json */
/* script */
<script>
  import { processComponentOption, getComponent, getWxsMixin } from "@mpxjs/webpack-plugin/lib/runtime/optionProcessor"
  var wxsModules = {}
  global.currentModuleId = "_1491d0a4"
  global.currentSrcMode = "wx"
  global.currentInject = {"moduleId":"_1491d0a4"}
  /** script content **/
  require("./slider-default.mpx.js?isComponent&outputPath=components%2Fslider-default1491d0a4%2Findex!=!@mpxjs/webpack-plugin/lib/selector?mode=web&env=!./slider-default.mpx?ctorType=component&index=0&isComponent&lang=js&mpx&outputPath=components%2Fslider-default1491d0a4%2Findex&type=script")

  export default processComponentOption({
    option: global.__mpxOptionsMap["_1491d0a4"],
    ctorType: "component",
    outputPath: "components/slider-default1491d0a4/index",
    pageConfig: {},
    // @ts-ignore
    componentsMap: {'cube-slider':getComponent(require("../../../packages/mpx-cube-ui/src/components/slider/index.mpx?isComponent&outputPath=components%2Findex999434b0%2Findex"))},
    componentGenerics: {},
    genericsInfo: undefined,
    wxsMixin: getWxsMixin(wxsModules),
    hasApp: true
  })
</script>